var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v(" © Fresh Clinics "+_vm._s(new Date().getFullYear()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }